import { MaterialService } from './material.service';
import { OccurrenceHistoryStatusList } from './../model/occurrenceHistoryStatusList.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable()
export class OccurrenceHistoryStatusService extends KiwixiService {

  apiOccurrenceStatusList = environment.server + 'occurrences_history_status/';

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,) {
    super(_http, _router, kiwixiGlobals, materialService);
  }


  getOccurrenceHistoryStatus(params: HttpParams): Observable<OccurrenceHistoryStatusList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<OccurrenceHistoryStatusList>(this.apiOccurrenceStatusList, {
      headers: header,
      params: params
    })
      .pipe(
        map(_invoices => _invoices),
        catchError(this.handleErrorObservable<OccurrenceHistoryStatusList>(`getOccurrenceHistoryStatus`))
      );
  }

}
